export function IsGeocoordinateRangeQuery(query?: string): boolean {
    if (!query) {
        return false;
    }
    return !!query.match(
        /\[(([-+]?)?\d+(\.\d+)?),\s*(([-+]?)?\d+(\.\d+)?) TO (([-+]?)?\d+(\.\d+)?),\s*(([-+]?)?\d+(\.\d+)?)\]$/
    );
}
